import { render, staticRenderFns } from "./SchoolDetail.vue?vue&type=template&id=cefcc0ce&scoped=true&"
import script from "./SchoolDetail.vue?vue&type=script&lang=js&"
export * from "./SchoolDetail.vue?vue&type=script&lang=js&"
import style0 from "./SchoolDetail.vue?vue&type=style&index=0&id=cefcc0ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cefcc0ce",
  null
  
)

export default component.exports